export default __webpack_public_path__ + "static/media/hiring_img1.727dc0ba.png";